export default __webpack_public_path__ + "static/media/Blog_Post_2.8562676a.jpg";